import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhitelabelOptionsListComponent } from './components/whitelabel-options-list/whitelabel-options-list.component';
import { RouterModule } from '@angular/router';
import { WhitelabelAndroidComponent } from './components/whitelabel-android/whitelabel-android.component';
import { WhitelabelIosComponent } from './components/whitelabel-ios/whitelabel-ios.component';
import { WhitelabelAppsListComponent } from './components/whitelabel-apps-list/whitelabel-apps-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileValueAccessor } from './directives/file-value-accessor.directive';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { WhitelabelCreateComponent } from './components/whitelabel-create/whitelabel-create.component';
import { SharedModule } from '../shared/shared.module';
import { WhitelabelRunComponent } from './components/whitelabel-run/whitelabel-run.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import SearchFilterWebappsPipe from '../shared/pipes/search-filter-webapps.pipe';
import { AlphabeticalSortPipe } from './pipes/alphabetical-sort-whitelabel-apps.pipe';
import SearchFilterAppPipe from './pipes/search-filter-whitelabel-app.pipe';
import { WhitelabelIosProvisioningProfilesUploadComponent } from './components/whitelabel-ios-provisioning-profiles-upload/whitelabel-ios-provisioning-profiles-upload.component';
import { WhitelabelIosCertificateUploadComponent } from './components/whitelabel-ios-certificate-upload/whitelabel-ios-certificate-upload.component';
import { WhitelabelIosIconsUploadComponent } from './components/whitelabel-ios-icons-upload/whitelabel-ios-icons-upload.component';
import { WhitelabelIosPlistUploadComponent } from './components/whitelabel-ios-plist-upload/whitelabel-ios-plist-upload.component';
import { WhitelabelAndroidCredentialsUploadComponent } from './components/whitelabel-android-credentials-upload/whitelabel-android-credentials-upload.component';
import { WhitelabelAndroidGoogleServicesUploadComponent } from './components/whitelabel-android-google-services-upload/whitelabel-android-google-services-upload.component';
import { WhitelabelAndroidIconsUploadComponent } from './components/whitelabel-android-icons-upload/whitelabel-android-icons-upload.component';
import { SortWhitelabelAppsByTypePipe } from './pipes/sort-whitelabel-apps-by-type.pipe';
import { WhitelabelPendingAppsListComponent } from './components/whitelabel-pending-apps-list/whitelabel-pending-apps-list.component';
import { TotalAllCountPipe, TotalPublishedCountPipe, TotalUnpublishedCountPipe, TotalIosPublishedCountPipe, TotalAndroidPublishedCountPipe } from './pipes/quantity-apps-whitelabel';
import { WhitelabelQrcodeComponent } from './components/whitelabel-qrcode/whitelabel-qrcode.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { WhitelabelQrcodeViewerComponent } from './components/whitelabel-qrcode-viewer/whitelabel-qrcode-viewer.component';
import { WhitelabelPendingAppConfirmConfigComponent } from './components/whitelabel-pending-app-confirm-config/whitelabel-pending-app-confirm-config.component';
import { WhitelabelBatchRunComponent } from './components/whitelabel-batch-run/whitelabel-batch-run.component';

@NgModule({
  declarations: [
    SearchFilterAppPipe,
    AlphabeticalSortPipe,
    WhitelabelOptionsListComponent,
    WhitelabelIosComponent,
    WhitelabelAndroidComponent,
    WhitelabelAppsListComponent,
    FileValueAccessor,
    WhitelabelCreateComponent,
    WhitelabelRunComponent,
    WhitelabelIosProvisioningProfilesUploadComponent,
    WhitelabelIosCertificateUploadComponent,
    WhitelabelIosIconsUploadComponent,
    WhitelabelIosPlistUploadComponent,
    WhitelabelAndroidCredentialsUploadComponent,
    WhitelabelAndroidGoogleServicesUploadComponent,
    WhitelabelAndroidIconsUploadComponent,
    SortWhitelabelAppsByTypePipe,
    WhitelabelPendingAppsListComponent,
    TotalPublishedCountPipe,
    TotalUnpublishedCountPipe,
    TotalIosPublishedCountPipe,
    TotalAndroidPublishedCountPipe,
    TotalAllCountPipe,
    WhitelabelQrcodeComponent,
    WhitelabelQrcodeViewerComponent,
    WhitelabelPendingAppConfirmConfigComponent,
    WhitelabelBatchRunComponent,
  ],
  imports: [
    QRCodeComponent,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    SharedModule,
    MatDialogModule,
    FormsModule,
    ToastrModule
  ]
})
export class WhitelabelModule { }
